<template>
	<client-only>
		<div v-show="!isExpired" class="flex" :class="wrapperClass">
			<div
				v-for="item in config"
				:key="item"
				class="lg:min-w-[175px] min-w-[48px] lg:mx-2 mx-1 lg:py-6 py-[6px] text-center rounded-2xl border-[3px] border-solid"
			>
				<span
					class="lg:text-[68px] lg:leading-[74px] text-[18px] leading-[22px] font-extrabold"
				>
					{{ timeValues[item] }}
				</span>
				<p class="lg:text-2xl text-[6px] font-bold">{{ $t(item) }}</p>
			</div>
		</div>
	</client-only>
</template>

<script setup lang="ts">
import { useCountdown } from "~/composables/useCountdown";

interface Props {
	startDate: string;
	wrapperClass?: string;
}

const { startDate } = defineProps<Props>();

const { isExpired, timeValues } = useCountdown(startDate || null) || {};

const config = ["days", "hours", "minutes", "seconds"];
</script>
